import { Pagination } from "services/search";
import { DataWithPagination } from "../types";
import {
  Calculation,
  CalculationDetail,
  CalculationEditFormValues,
  CalculationRow,
} from "./types";
import {
  transformCalculation,
  transformCalculationDetail,
  transformCalculationOnCreate,
  transformCalculationRow,
} from "./transformations";
import { createApiCall, paginatedApiCall } from "../createApiCall";

/*---------------------------------------------------------------------------------------
  SEARCH
-----------------------------------------------------------------------------------------*/
export const getCalculationsAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<CalculationRow>> => {
  let path = `/v1/calculations?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformCalculationRow);
};

/*---------------------------------------------------------------------------------------
    DETAIL VIEW
-----------------------------------------------------------------------------------------*/
export const getCalculationAPI = async (
  calculationId: string
): Promise<CalculationDetail> => {
  const response = await createApiCall({
    path: `/v1/calculations/${calculationId}`,
    method: "GET",
  })();

  return transformCalculationDetail(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - CREATE
-----------------------------------------------------------------------------------------*/
export const createCalculationAPI = async (
  formValues: CalculationEditFormValues
): Promise<Calculation> => {
  const response = await createApiCall(
    {
      path: "/v1/calculations/",
      method: "POST",
      body: transformCalculationOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Tablica ostatka vrijednosti je uspješno kreiran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformCalculation(response.data);
};

